export const URL_PATH_TRANSACTION_LIST = '/unmatched-transactions'
export const URL_PATH_TRANSACTION_DETAILS = '/unmatched-transactions/:id'
